import { Controller } from '@hotwired/stimulus'

// Both report sections stay on /wmata/reports. The buttons only swap panels.
export default class extends Controller {
  static targets = ['tab', 'panel']

  show (event) {
    const name = event.params.name
    this.tabTargets.forEach((tab) => {
      tab.classList.toggle('active', tab.dataset.name === name)
    })
    this.panelTargets.forEach((panel) => {
      panel.classList.toggle('hidden', panel.dataset.name !== name)
    })
  }
}
